import _ from "lodash";
import { Units } from "../../constants/Constants";

class BillSummary {
  data: any[];
  sheet_name: string;
  type: any;
  parsed: any[];

  constructor(data: any, sheet_name: string) {
    this.data = data;
    this.type = "";
    this.parsed = [];
    this.sheet_name = sheet_name;
  }

  parseBoq() {
    let start = -1;
    this.data.forEach((col: any[], index) => {
      if (this.isTableState(col)) start = index;
      else if (start !== -1) {
        // Trim whitespace and check for valid data
        const description = col[1] ? String(col[1]).trim() : null;
        const unit = col[2] ? String(col[2]).trim() : null;
        const amountValue = col[3] !== undefined && col[3] !== null ? col[3] : null;
        
        if (description && unit && amountValue !== null) {
          // Convert amount to number, handle both string and number inputs
          const amount = typeof amountValue === 'string' 
            ? parseFloat(amountValue.replace(/,/g, '')) || 0
            : Number(amountValue) || 0;
          
          this.parsed.push({
            description: description,
            unit: unit,
            amount: amount,
            key: this.parsed.length,
          });
        } else if (description && unit && (amountValue === null || amountValue === '')) {
          // Handle case where amount is in col[2] and unit defaults to "Birr"
          const amount = typeof col[2] === 'string' 
            ? parseFloat(String(col[2]).replace(/,/g, '')) || 0
            : Number(col[2]) || 0;
          
          this.parsed.push({
            description: description,
            unit: "Birr",
            amount: amount,
            key: this.parsed.length,
          });
        }
      }
    });
    return this.parsed;
  }

  private isTableState(col: any[]) {
    return (
      _.isString(col[1]) &&
      _.isString(col[2]) 
    );
  }

}
export default BillSummary;
